import React, { useState } from "react";
import { Modal, Typography, Button, Grid, List, ListItem, Collapse, styled } from "@mui/material";
import { formatNumberAsEuro, parseEuropeanNumber, formatCurrency } from "./helpers";
import PricingDetails from "./PricingDetails";

const ModalContent = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    maxHeight: '80vh',
    overflowY: 'auto',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary, // Ensure this is set to a color visible on the background
    border: 'none',
}));

const StyledPriceDetails = styled(Grid)(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 0),
    '&:last-child': {
        borderBottom: 'none',
    },
}));


const ProductDetailsModal = ({ modalOpen, handleCloseModal, dubbeleMeter, modalProduct, chosenEntity, electricityTotalParsed, gasTotalParsed, returnsAvailableForAgent }) => {

    return (
        <Modal
            open={modalOpen}
            onClose={handleCloseModal}
            aria-labelledby="pricing-details-title"
            aria-describedby="pricing-details-description"

        >
            <ModalContent className="pricing-details-modal">
                <div
                    className="icon-as-close icon-size closeButton"
                    onClick={handleCloseModal}
                    style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer', width: '2rem', height: '2rem' }}
                ></div>
                <Typography id="pricing-details-title" variant="h6" component="h2">
                    Prijsopbouw verwachte kosten
                </Typography>
                <div id="pricing-details-description">
                    <PricingDetails
                        product={modalProduct}
                        dubbeleMeter={dubbeleMeter}
                        chosenEntity={chosenEntity}
                        isBusiness={chosenEntity === "Zakelijk"}
                        returnsAvailableForAgent={returnsAvailableForAgent}
                        
                    />
                </div>
                <div className="navigation">
                    <a onClick={handleCloseModal} className='btn btn-primary'>Sluit</a>
                </div>
            </ModalContent>
        </Modal>
    );
};



export default ProductDetailsModal;
